import React from 'react';
import { useTranslation } from '@lt/localization';
import { EmptyReviews as EmptyReviewsIcon } from '@lt/components/icons-react/userflow';
import classnames from 'classnames';
import { TEST_ID_NOT_ENOUGH_REVIEW_TEXT } from './constants';

import styles from './notEnoughtReviews.module.css';

interface Props {
  isEmptyReviews: boolean;
  className?: string;
}

const NotEnoughReviews = ({ isEmptyReviews, className = '' }: Props) => {
  const { t } = useTranslation();
  const title = isEmptyReviews
    ? t('hotel.reviews.emptyTitle')
    : t('hotel.reviews.fewTitle');
  return (
    <div
      className={classnames(styles.notEnoughtReviews, className, {
        [styles.emptyReviews]: isEmptyReviews,
      })}
    >
      {isEmptyReviews && <EmptyReviewsIcon width={165} />}
      <div
        className={styles.title}
        data-testid={TEST_ID_NOT_ENOUGH_REVIEW_TEXT}
      >
        {title}
      </div>
      <div className={styles.subTitle}>{t('hotel.reviews.emptySubtitle')}</div>
    </div>
  );
};

export default NotEnoughReviews;
